export default {
    TITLE: 'Profile',
};
